import React from "react";


function Process() {
    return(
        <div style={{position: "relative", width: "100vw", marginLeft: "auto", marginRight: "auto", marginTop: "10rem"}}>
            <span className='display-large h1' style={{width: "70vw", marginInline: "auto"}} >
                Design Process
            </span>

            <img src="https://ik.imagekit.io/poonr2gma/design%20process-min(1).png?updatedAt=1695528446473" style={{width: "100vw", marginTop: "4rem"}}/>
            
        </div>
        
        
    )
}

export default Process;
